import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatasetCards = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 528 201",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dd_1324_3168)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip0_1324_3168)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M3.31763 9.41728C3.31763 5.32083 6.63845 2 10.7349 2H159.08C163.177 2 166.498 5.32083 166.498 9.41727V189.904C166.498 194.001 163.177 197.321 159.08 197.321H10.7349C6.63844 197.321 3.31763 194.001 3.31763 189.904V9.41728Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsxs("g", {
						clipPath: "url(#clip1_1324_3168)",
						children: [/* @__PURE__ */ _jsx("rect", {
							width: 189.824,
							height: 40.2656,
							transform: "translate(2.31763 -18.2656)",
							fill: "#613DE5"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M2.31763 15.0969C2.31763 12.2377 4.63545 9.91992 7.49464 9.91992H62.9178C66.2038 9.91992 69.3331 11.3251 71.5162 13.7811L92.6277 37.5306H2.31763V15.0969Z",
							fill: "white"
						})]
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 54.415,
						width: 47.2796,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 99.8652,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 110.744,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 121.622,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 132.501,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 143.38,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 154.258,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 175.069,
						width: 70.6706,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 125.708,
						y: 174.688,
						width: 24.3104,
						height: 11.7361,
						rx: 5.86803,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 19.9795,
						y: 69.25,
						width: 128.899,
						height: 18.7904,
						rx: 1.97794,
						fill: "#D9D9D9"
					})
				]
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_dd_1324_3168)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip2_1324_3168)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M182.569 9.41728C182.569 5.32083 185.89 2 189.986 2H338.332C342.428 2 345.749 5.32083 345.749 9.41727V189.904C345.749 194.001 342.428 197.321 338.332 197.321H189.986C185.89 197.321 182.569 194.001 182.569 189.904V9.41728Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 54.415,
						width: 47.2796,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 99.8652,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 110.744,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 121.622,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 132.501,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 143.38,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 154.258,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 175.069,
						width: 70.6706,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 304.962,
						y: 174.688,
						width: 24.3104,
						height: 11.7361,
						rx: 5.86803,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 199.234,
						y: 69.25,
						width: 128.899,
						height: 18.7904,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsxs("g", {
						clipPath: "url(#clip3_1324_3168)",
						children: [/* @__PURE__ */ _jsx("rect", {
							width: 189.824,
							height: 40.2656,
							transform: "translate(181.318 -18.2656)",
							fill: "#E43DC9"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M181.318 15.0969C181.318 12.2377 183.635 9.91992 186.495 9.91992H241.918C245.204 9.91992 248.333 11.3251 250.516 13.7811L271.628 37.5306H181.318V15.0969Z",
							fill: "white"
						})]
					})
				]
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_dd_1324_3168)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip4_1324_3168)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M361.82 9.41728C361.82 5.32083 365.141 2 369.237 2H517.583C521.679 2 525 5.32083 525 9.41727V189.904C525 194.001 521.679 197.321 517.583 197.321H369.237C365.141 197.321 361.82 194.001 361.82 189.904V9.41728Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 54.415,
						width: 47.2796,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 99.8652,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 110.744,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 121.622,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 132.501,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 143.38,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 154.258,
						width: 128.899,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 175.069,
						width: 70.6706,
						height: 8.90072,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 484.214,
						y: 174.688,
						width: 24.3104,
						height: 11.7361,
						rx: 5.86803,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsx("rect", {
						opacity: .4,
						x: 378.485,
						y: 69.25,
						width: 128.899,
						height: 18.7904,
						rx: 1.97794,
						fill: "#D9D9D9"
					}),
					/* @__PURE__ */ _jsxs("g", {
						clipPath: "url(#clip5_1324_3168)",
						children: [/* @__PURE__ */ _jsx("rect", {
							width: 189.824,
							height: 40.2656,
							transform: "translate(361.318 -18.2656)",
							fill: "#1DA854"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M361.318 15.0969C361.318 12.2377 363.635 9.91992 366.495 9.91992H421.918C425.204 9.91992 428.333 11.3251 430.516 13.7811L451.628 37.5306H361.318V15.0969Z",
							fill: "white"
						})]
					})
				]
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_1324_3168",
				x: .845203,
				y: .516546,
				width: 168.125,
				height: 200.266,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .494485 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .247242 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1324_3168"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .98897 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.23621 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_1324_3168",
						result: "effect2_dropShadow_1324_3168"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_1324_3168",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_dd_1324_3168",
				x: 180.096,
				y: .516546,
				width: 168.125,
				height: 200.266,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .494485 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .247242 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1324_3168"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .98897 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.23621 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_1324_3168",
						result: "effect2_dropShadow_1324_3168"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_1324_3168",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dd_1324_3168",
				x: 359.348,
				y: .516546,
				width: 168.125,
				height: 200.266,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .494485 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .247242 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1324_3168"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .98897 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.23621 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_1324_3168",
						result: "effect2_dropShadow_1324_3168"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_1324_3168",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_1324_3168",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M3.31763 9.41728C3.31763 5.32083 6.63845 2 10.7349 2H159.08C163.177 2 166.498 5.32083 166.498 9.41727V189.904C166.498 194.001 163.177 197.321 159.08 197.321H10.7349C6.63844 197.321 3.31763 194.001 3.31763 189.904V9.41728Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_1324_3168",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 189.824,
					height: 40.2656,
					fill: "white",
					transform: "translate(2.31763 -18.2656)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_1324_3168",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M182.569 9.41728C182.569 5.32083 185.89 2 189.986 2H338.332C342.428 2 345.749 5.32083 345.749 9.41727V189.904C345.749 194.001 342.428 197.321 338.332 197.321H189.986C185.89 197.321 182.569 194.001 182.569 189.904V9.41728Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip3_1324_3168",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 189.824,
					height: 40.2656,
					fill: "white",
					transform: "translate(181.318 -18.2656)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip4_1324_3168",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M361.82 9.41728C361.82 5.32083 365.141 2 369.237 2H517.583C521.679 2 525 5.32083 525 9.41727V189.904C525 194.001 521.679 197.321 517.583 197.321H369.237C365.141 197.321 361.82 194.001 361.82 189.904V9.41728Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip5_1324_3168",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 189.824,
					height: 40.2656,
					fill: "white",
					transform: "translate(361.318 -18.2656)"
				})
			})
		] })
	]
});
export default SvgDatasetCards;
